import React from 'react';
import { Menu, Button, Row } from 'antd';
import { InferenceFile } from '../../../types';
import { Icon } from '@ant-design/compatible';
import { TopBar } from '../../../components/layout/TopBar';

type Props = {
  currentInferenceId: string;
  inferenceList: InferenceFile[];
  onInferenceSelect: (inferenceId: string) => any;
  onClose: () => any;
  onCompare: () => any;
};

const CompareHeader = (props: Props) => {
  const { currentInferenceId, inferenceList, onInferenceSelect, onClose, onCompare } = props;

  return (
    <>
      <TopBar
        title=""
        closeFunction={(event: any) => {
          event.preventDefault();
          event.stopPropagation();
          onClose();
        }}>
        {inferenceList && (
          <Row className="w-full justify-start">
            <Menu mode="horizontal" selectedKeys={[currentInferenceId]} className="w-1/2 justify-end mt-2 ml-5">
              {inferenceList.map(inference => (
                <Menu.Item
                  key={inference.id}
                  onClick={() => onInferenceSelect(inference.id)}
                  disabled={inference.status === 'PROCESSING'}>
                  {inference.status === 'PROCESSING' && <Icon type="loading" style={{ color: '#999EA6' }} spin />}
                  <span
                    style={{
                      color: inference.status === 'PROCESSING' ? '#999EA6' : '#494a50',
                    }}>
                    {inference.model && inference.model.name} - {inference.modelVersion && inference.modelVersion.name}
                  </span>
                </Menu.Item>
              ))}
            </Menu>
            <Row className="items-center">
              <Button type="link" onClick={onCompare}>
                <Icon type="plus-circle" />
                Compare
              </Button>
            </Row>
          </Row>
        )}
      </TopBar>
    </>
  );
};

export default CompareHeader;
